import React, { useState } from "react";
import "./HomeMapSection.css";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

const countries = [
  {
    name: "UAE",
    flag: "/assets/homepageicons/UAE.svg",
    office: "UAE Office",
    // location: "NAIROBI, DRC",
    phone: "058-627-9149 ",
    whatsapp: "058-627-9149",
    email: "connect@tnsglobal.co",
    bg: true,
    top: "76%",
    left: "44%",
  },

  {
    name: "Kenya",
    flag: "/assets/homepageicons/Kenya.svg",
    office: "Kenya Office",
    // location: "NAIROBI, DRC",
    phone: "058-627-9149 ",
    whatsapp: "058-627-9149",
    email: "Manager.nbo@sabre.tnsglobal.co",
    bg: true,
    top: "58.5%",
    left: "49%",
  },

  {
    name: "Uganda",
    flag: "/assets/homepageicons/Uganda.svg",
    office: "Uganda Office",
    // location: "NAIROBI, DRC",
    phone: "(+256)776908414",
    whatsapp: "058-627-9149 ",
    email: "Acc1.ebb@sabre.tnsglobal.co",
    bg: true,
    // top: "40%",
    // left: "66%",
  },

  {
    name: "Tanzania",
    flag: "/assets/homepageicons/Tanzania.svg",
    office: "Tanzania Office",
    // location: "NAIROBI, DRC",
    phone: "(+255)752040245",
    whatsapp: "058-627-9149",
    email: "accounts.dar@sabre.tnsglobal.co",
    bg: true,
    top: "48%",
    left: "47%",
  },

  {
    name: "Zambia",
    flag: "/assets/homepageicons/Zambia.svg",
    office: "Zambia Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279149",
    whatsapp: "058-627-9149",
    email: "Manager.lun@sabre.tnsglobal.co",
    bg: true,
    top: "53.5%",
    left: "40%",
  },

  {
    name: "Zimbabwe",
    flag: "/assets/homepageicons/Zimbabwe.svg",
    office: "Zimbabwe Office",
    // location: "NAIROBI, DRC",
    phone: "(+263)785848993",
    whatsapp: "058-627-9149",
    email: "manager.hre@sabre.tnsglobal.co",
    bg: true,
    top: "69%",
    left: "43.5%",
  },

  {
    name: "Angola",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Angola.png",
    office: "Angola Office",
    // location: "NAIROBI, DRC",
    phone: "(+244) 931 258016",
    whatsapp: "058-627-9149",
    email: "assistantmanager@sabre.tnsglobal.co",
    top: "67%",
    left: "34%",
  },

  {
    name: "Botswana",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Botswana.png",
    office: "Botswana Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279149",
    whatsapp: "058-627-9149",
    email: "marketing.gbe@sabre.tnsglobal.co",
    top: "77%",
    left: "57.5%",
  },

  {
    name: "Madagascar",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Madagascar.png",
    office: "Madagascar Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279152",
    whatsapp: "058-627-9149",
    email: "connect@tnsglobal.co",
    top: "80%",
    left: "39%",
  },

  {
    name: "Malawi",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Malawi.png",
    office: "Malawi Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279149",
    whatsapp: "058-627-9149",
    email: "connect@tnsglobal.co",
    top: "68%",
    left: "51.6%",
  },

  {
    name: "Mozambique",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Mazambique.png",
    office: "Mozambique Office",
    // location: "NAIROBI, DRC",
    phone: "+258 87 786 0288",
    whatsapp: "058-627-9149",
    email: "Manager.mpm@sabre.tnsglobal.co",
    top: "70%",
    left: "48%",
  },

  {
    name: "Namibia",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Namibia.png",
    office: "Namibia Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279150",
    whatsapp: "058-627-9149",
    email: "connect@tnsglobal.co",
    top: "78%",
    left: "33.3%",
  },

  {
    name: "Congo DRC",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/RDC.png",
    office: "DRC Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279151",
    whatsapp: "058-627-9149",
    email: "connect@tnsglobal.co",
    top: "51%",
    left: "33%",
  },

  {
    name: "Central Africa Republic",
    flag: "https://flagcdn.com/w320/cf.png",
    office: "Central Africa Republic Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279153",
    whatsapp: "058-627-9149",
    email: "connect@tnsglobal.co",
    top: "49%",
    left: "51%",
  },

  {
    name: "Congo Republic",
    flag: "https://flagcdn.com/w320/cg.png",
    office: "Congo Office",
    // location: "NAIROBI, DRC",
    phone: "(+971)-058-6279154",
    whatsapp: "058-627-9149",
    email: "connect@tnsglobal.co",
    top: "41.5%",
    left: "37%",
  },
];
// const countries = [
//     {
//         name: "UAE",
//         flag: "/assets/homepageicons/UAE.svg",
//         office: "UAE Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Qatar",
//         flag: "/assets/homepageicons/Qatar.svg",
//         office: "Qatar Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "India",
//         flag: "/assets/homepageicons/India.svg",
//         office: "India Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Kenya",
//         flag: "/assets/homepageicons/Kenya.svg",
//         office: "Kenya Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Uganda",
//         flag: "/assets/homepageicons/Uganda.svg",
//         office: "Uganda Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Tanzania",
//         flag: "/assets/homepageicons/Tanzania.svg",
//         office: "Tanzania Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Zambia",
//         flag: "/assets/homepageicons/Zambia.svg",
//         office: "Zambia Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Zimbabwe",
//         flag: "/assets/homepageicons/Zimbabwe.svg",
//         office: "Zimbabwe Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "South Africa",
//         flag: "/assets/homepageicons/South-Africa.svg",
//         office: "South Africa Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },

//     // Southeast Asia cluster
//     {
//         name: "Malaysia",
//         flag: "/assets/homepageicons/Malaysia.svg",
//         office: "Malaysia Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Singapore",
//         flag: "/assets/homepageicons/Singapore.png",
//         office: "Singapore Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: true,
//     },
//     {
//         name: "Saudi Arabia",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/saudi_arabia.png",
//         office: "Saudi Arabia Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },

//     {
//         name: "Kazakhstan",
//         flag: "https://flagcdn.com/w320/kz.png",
//         office: "Kazakhstan Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//         bg: false,
//     },

//     {
//         name: "Algeria",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Algeria.png",
//         office: "Algeria Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Angola",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Angola.png",
//         office: "Angola Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Bamako",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Bamako.png",
//         office: "Bamako Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Botswana",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Botswana.png",
//         office: "Botswana Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Burkina",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Burkina.png",
//         office: "Burkina Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Burundi",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Burundi.png",
//         office: "Burundi Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Cameroon",
//         flag: "https://flagcdn.com/w320/cm.png",
//         office: "Cameroon Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Comoros",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/images/newImgs/countries/comoros.png",
//         office: "Comoros Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     { name: "Congo",
//          flag: "https://flagcdn.com/w320/cg.png",
//         office: "Congo Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//          },
//     {
//         name: "Gabon",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Gabon.png",
//         office: "Gabon Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Ghana",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Ghana.png",
//         office: "Ghana Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Guinea",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/images/newImgs/countries/Guinea.jpg",
//         office: "Guinea Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Ivory Coast",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Ivory.png",
//         office: "Ivory Coast Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },

//     {
//         name: "Liberia",
//         flag: "https://flagcdn.com/w320/lr.png",
//         office: "Liberia Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Madagascar",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Madagascar.png",
//         office: "Madagascar Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Malawi",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Malawi.png",
//         office: "Malawi Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Mozambique",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Mazambique.png",
//         office: "Mozambique Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Namibia",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Namibia.png",
//         office: "Namibia Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Nigeria",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Nigeria.png",
//         office: "Nigeria Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "DRC",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/RDC.png",
//         office: "DRC Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Rwanda",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Rawanda.png",
//         office: "Rwanda Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Senegal",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/senegal.png",
//         office: "Senegal Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
//     {
//         name: "Sierra Leone",
//         flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/sierra.png",
//         office: "Sierra Leone Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },

//     {
//         name: "Togo",
//         flag: "https://blueberrywebsites.azureedge.net/bbt/images/Togo.png",
//         office: "Togo Office",
//         location: "NAIROBI, DRC",
//         phone: "+254 7XX XXX XXX",
//         whatsapp: "+254 7XX XXX XXX",
//         email: "kenya.support@tnsglobal.africa",
//     },
// ];
const HomeMapSection = () => {
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState(
    countries.find((c) => c.name === "UAE"),
  );
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  return (
    <>
      <section className="section-padding map-section">
        <h2 className="heading-title" style={{ color: "#1E1E1E" }}>
          Our Footprints
          <span className="title-blue"> Across Africa </span>
        </h2>
        <p className="desc">
          Operating across 14 African countries, TNS Global supports travel
          agencies with Sabre-powered systems, local market expertise, and
          hands-on assistance to strengthen operations and expand global
          connectivity.
        </p>
        <div className="map-container">
          <div className="map-container-img">
            <img
              src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/home-flag.png"
              alt="world map"
              className="map-image"
            />
            <div className="map-hotspots">
              {countries
                .filter((country) => country.top && country.left)
                .map((country) => (
                  <div
                    key={country.name}
                    className={`map-hotspot ${
                      selectedCountry?.name === country.name ? "active" : ""
                    }`}
                    style={{
                      top: country.top,
                      left: country.left,
                    }}
                    onMouseEnter={() => setSelectedCountry(country)}
                    onClick={() => setSelectedCountry(country)}
                  />
                ))}
            </div>

            <div className="pin-popup">
              <div className="popup-header">
                <img 
                  src={selectedCountry?.flag}
                  alt={selectedCountry?.name}
                  style={{ width: "25px", height: "25px", borderRadius: "50%" }}
                />

                <div className="popup-header-div">
                  <h5>{selectedCountry?.office}</h5>
                  <p>{selectedCountry?.location}</p>
                </div>
              </div>

              <div className="popup-item">
                <img
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/phone.svg"
                  alt="Phone"
                />

                <div className="popup-header-div">
                  <h6>Contact No.</h6>

                  <a
                    href={`tel:${selectedCountry?.phone?.replace(/\s+/g, "")}`}
                    className="popup-link"
                  >
                    {selectedCountry?.phone}
                  </a>
                </div>
              </div>

              <div className="popup-item">
                <img
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/whatsapp-new.svg"
                  alt="WhatsApp"
                />

                <div className="popup-header-div">
                  <h6>WhatsApp No.</h6>

                  <span
                    className="popup-link"
                    onClick={() => {
                      navigator.clipboard.writeText(selectedCountry?.whatsapp);
                      alert("WhatsApp number copied!");
                    }}
                  >
                    {selectedCountry?.whatsapp}
                  </span>
                </div>
              </div>

              <div className="popup-item">
                <img
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/email.svg"
                  alt="Email"
                />

                <div className="popup-header-div">
                  <h6>Email</h6>

                  <span
                    className="popup-link"
                    onClick={() => {
                      navigator.clipboard.writeText(selectedCountry?.email);
                      alert("Email copied!");
                    }}
                  >
                    {selectedCountry?.email}
                  </span>
                </div>
              </div>
            </div>

            <div className="activeDestination">
              <img
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/map-icon.svg"
                alt="location pin"
                style={{ width: "15px" }}
              />
              Hover or tap any country to view its local office, email &
              WhatsApp contact
            </div>
          </div>
          <div className="map-dropdown-div">
            <div className="map-search-box">
              <span className="search-icon">
                <FiSearch />
              </span>
              <input
                type="text"
                placeholder="Search by country..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="country-list">
              {filteredCountries.length > 0 ? (
                filteredCountries.map((country, index) => (
                  <div key={index} className="country-item-div">
                    <div
                      className={`country-item ${
                        selectedCountry?.name === country.name ? "active" : ""
                      }`}
                      onMouseEnter={() => setSelectedCountry(country)}
                      onClick={() => setSelectedCountry(country)}
                    >
                      <img
                        src={country.flag}
                        alt={country.name}
                        className="country-flag"
                      />

                      <span>{country.name}</span>
                    </div>

                    {selectedCountry?.name === country.name && (
                      <div className="country-popup-mobile">
                        <div className="popup-header">
                          <img
                            src={country.flag}
                            alt={country.name}
                            style={{ width: 25, height: 25}}
                          />

                          <div className="popup-header-div">
                            <h5>{country.office}</h5>
                            <p>{country.location}</p>
                          </div>
                        </div>

                        <div className="popup-item">
                          <img
                            src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/phone.svg"
                            alt=""
                          />

                          <div className="popup-header-div">
                            <h6>Contact No.</h6>

                            <a
                              href={`tel:${country.phone.replace(/\s+/g, "")}`}
                            >
                              {country.phone}
                            </a>
                          </div>
                        </div>

                        <div className="popup-item">
                          <img
                            src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/whatsapp-new.svg"
                            alt=""
                          />

                          <div className="popup-header-div">
                            <h6>WhatsApp No.</h6>

                            <span
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  selectedCountry?.whatsapp,
                                );
                                alert("WhatsApp number copied!");
                              }}
                            >
                              {country.whatsapp}
                            </span>
                          </div>
                        </div>

                        <div className="popup-item">
                          <img
                            src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/email.svg"
                            alt=""
                          />

                          <div className="popup-header-div">
                            <h6>Email</h6>

                            <span
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  selectedCountry?.email,
                                );
                                alert("Email copied!");
                              }}
                            >
                              {country.email}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="no-results">No countries found</div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeMapSection;
